export const Filter = () => {
  const $form = document.querySelector('.js--filter-by-country');

  if ($form) {
    $form.addEventListener('change', (e) => {
      e.preventDefault();

      let items = $form.closest('section').querySelectorAll($form.getAttribute('data-filter-items'));
      const value = $form.getElementsByTagName('select')[0].value;

      [...items].forEach((el) => {
        const dataValue = el.getAttribute('data-country');

        if (value !== dataValue && value !== 'all') {
          el.parentElement.style.display = 'none';
        } else {
          el.parentElement.style.display = 'block';
        }
      });
    });
  }
}
